import { call, put, takeLatest } from "redux-saga/effects";
import { API_ENDPOINTS } from "../../../../util/constants";
import {
  createHeadersWithAuth,
  createQueryString,
  requestPromise
} from "../../../../util/request";
import { actions } from "../../../Dashboard/_redux/dashboardRedux";
import {
  fetchAgentBreakDetailsSuccess,
  fetchAgentStatusDataSuccess,
  fetchTotalAgentsListSuccess,
  FETCH_AGENT_ON_BREAK_DETAILS,
  FETCH_AGENT_STATUS,
  FETCH_TOTAL_AGENT_LIST
} from "../actions/agentStatusActions";

function* getAgentStatusData(action) {
  let requestURL = API_ENDPOINTS.getCallMonitoringAgentStatus;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  yield put(
    actions.setLoadingState({
      resource: "call_agent_status",
      loading_state: "loading",
    })
  );
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(fetchAgentStatusDataSuccess(response, options.method));
    yield put(
      actions.setLoadingState({
        resource: "call_agent_status",
        loading_state: "loaded",
      })
    );
  } catch (error) {}
}

function* getAgentsOnBreakDetails(action) {
  let requestURL = API_ENDPOINTS.getCallMonitoringAgentsStatusOnBreakDetails;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  yield put(
    actions.setLoadingState({
      resource: "call_agent_status",
      loading_state: "loading",
    })
  );
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(fetchAgentBreakDetailsSuccess(response, options.method));
    yield put(
      actions.setLoadingState({
        resource: "call_agent_status",
        loading_state: "loaded",
      })
    );
  } catch (error) {}
}

function* getTotalAgentsList(action) {
  let requestURL = API_ENDPOINTS.getTotalAgentsList;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  yield put(
    actions.setLoadingState({
      resource: "call_agent_status",
      loading_state: "loading",
    })
  );
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(fetchTotalAgentsListSuccess(response, options.method));
    yield put(
      actions.setLoadingState({
        resource: "total_agents",
        loading_state: "loaded",
      })
    );
  } catch (error) {}
}

export default function* callMonitoringAgentStatusSaga() {
  yield takeLatest(FETCH_AGENT_STATUS, getAgentStatusData);
  yield takeLatest(FETCH_AGENT_ON_BREAK_DETAILS, getAgentsOnBreakDetails);
  yield takeLatest(FETCH_TOTAL_AGENT_LIST, getTotalAgentsList);
}
